import { Injectable, computed, signal } from '@angular/core';

type AiAssistantDialogStatus = 'closed' | 'open';

@Injectable({
  providedIn: 'root',
})
export class AiAssistantStateStore {
  private readonly status = signal<AiAssistantDialogStatus>('closed');

  readonly isOpen = computed(() => this.status() !== 'closed');

  open(): void {
    this.status.set('open');
  }

  close(): void {
    this.status.set('closed');
  }
}
